export default function ClipText(value: string, maxLength: number = 27) {
    let text: string = '';
    if (value.length > maxLength) {
        text = `${value.slice(0, maxLength)}...`;
    } else {
        text = value;
    }
    return text;
}
